export default __webpack_public_path__ + "static/SR India - FSSC 22000 - Certificate-5db8fb552aff6d6da2e810d2d9663104.pdf";